export const InvitationRoutes = {
  simulation: { home: 'simulation-invitation', repondre: 'repondre-simulation', fin: 'fin-simulation' },
  candidat: { home: 'home-invitation', repondre: 'repondre-test', fin: 'fin-test' }
};
